import React from "react";
import { motion } from "framer-motion";
import {
  UserCog,
  Globe2,
  LineChart,
  Medal,
  HeartHandshake,
  Compass,
} from "lucide-react";
import { DIFFERENTIATORS } from "@/data/siteContent";

const ICONS = { UserCog, Globe2, LineChart, Medal, HeartHandshake, Compass };

export default function WhyAceMax() {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 md:py-32 bg-[#FAFAF7]">
      <div className="container-prose">
        <div className="max-w-3xl">
          <p className="eyebrow mb-5">— Why AceMax</p>
          <h2 className="font-serif text-navy text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            What sets us <span className="italic">apart.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {DIFFERENTIATORS.map((d, i) => {
            const Icon = ICONS[d.icon];
            return (
              <motion.div
                key={d.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: i * 0.07 }}
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`differentiator-${i}`}
                className="group relative bg-white p-8 md:p-10 border border-navy/10 hover:border-navy/30 rounded-sm transition-all duration-500 hover:shadow-[0_24px_60px_-32px_rgba(27,42,94,0.3)] hover:-translate-y-1"
              >
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gold scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-sm bg-navy text-gold group-hover:bg-gold group-hover:text-navy transition-colors duration-500">
                  {Icon ? <Icon size={24} strokeWidth={1.5} /> : null}
                </div>
                <h3 className="font-serif text-navy text-2xl md:text-[1.6rem] mb-3 leading-tight">
                  {d.title}
                </h3>
                <p className="text-navy-deeper/70 text-sm md:text-[15px] leading-relaxed">
                  {d.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
